import React from 'react';
import { Pressable, StyleSheet, TextStyle, ViewStyle } from 'react-native';

import { Text, theme } from '@socrait/react';

interface HyperLinkProps {
  onPress: () => void;
  children: React.ReactNode;
  style?: TextStyle;
  containerStyle?: ViewStyle;
  variant?: 'primary' | 'subdued';
}

export const HyperLink = ({ onPress, children, style, containerStyle, variant = 'primary' }: HyperLinkProps) => {
  return (
    <Pressable
      onPress={onPress}
      style={({ pressed }) => [styles.inlinePressable, pressed && styles.linkPressed, containerStyle]}>
      <Text style={[variant === 'primary' ? styles.primaryLink : styles.subduedLink, style]}>{children}</Text>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  inlinePressable: {
    display: 'inline-flex',
  },
  linkPressed: {
    opacity: 0.8,
  },
  primaryLink: {
    color: theme.colors.primaryPurple,
  },
  subduedLink: {
    color: theme.colors.black,
    textAlign: 'center',
    fontFamily: theme.fonts.regular,
    fontSize: theme.fontSizes.xsmall,
  },
});
